<template>
  <v-container fill-height>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="card" color="primary">
          <v-card-title class="justify-center font-weight-bold">Buscar personal</v-card-title>
          <v-card-text>
            <BaseInput v-model="busquedaPersonal.nombre" label="Nombre"></BaseInput>
            <BaseInput v-model="busquedaPersonal.segundoNombre" label="Segundo nombre"></BaseInput>
            <BaseInput v-model="busquedaPersonal.apaterno" label="Apellido paterno"></BaseInput>
            <BaseInput v-model="busquedaPersonal.amaterno" label="Apellido materno"></BaseInput>
            <BaseInput v-model="busquedaPersonal.curp" label="CURP"></BaseInput>
            <BaseInput v-model="busquedaPersonal.CUIP" label="CUIP"></BaseInput>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <TextButton
                    color="secondary"
                    @click="triggerSearchPersonal()"
                    :disabled="loading || emptyForm"
                    :loading="loading"
                  >
                    Realizar búsqueda
                  </TextButton>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <TextButton @click="RESET_BUSQUEDA_PERSONAL()">Realizar nueva búsqueda</TextButton>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <BaseInput label="Filtrar elementos" v-model="filtroPersonal"></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="card" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!hasFoto(personal) || personal.fotoError">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.fotoError = true"
                  />
                </v-col>
                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="text-caption primary--text">Adscripción</div>
                  <div class="text-subtitle-1 primary--text">
                    {{
                      personal.CatPuestoDependencia.catDependencia.nombre
                        ? personal.CatPuestoDependencia.catDependencia.nombre
                        : 'Sin adscripción'
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="secondary darken-1">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2"
                        elevation="8"
                        :to="{ name: 'asignaEquipamiento', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-briefcase-plus</v-icon></v-btn
                      >
                    </template>
                    <span>Asignar equipamiento</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2"
                        elevation="8"
                        :to="{ name: 'historicoRegistroEquipamiento', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-list-box-outline</v-icon></v-btn
                      >
                    </template>
                    <span>Historico de asignacion del equipamiento</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2"
                        elevation="8"
                        icon
                        @click="generarConstanciaNoAdeudoAntimotin(personal)"
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-word</v-icon></v-btn
                      >
                    </template>
                    <span>Constancia de No Adeudo Antimotin</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
/* Estilos modernos para Personal Equipamiento */
.card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

.card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4);
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

/* Card title */
::v-deep .v-card-title {
  padding: 16px;
  background: rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

/* Card text */
::v-deep .v-card-text {
  padding: 16px;
}

/* Card actions */
::v-deep .v-card-actions {
  padding: 12px 16px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

/* Títulos y textos - Negro sobre color del módulo para máximo contraste */
.text-h6.font-weight-bold {
  color: #1a2e24 !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
}

.primary--text {
  color: rgba(26, 46, 36, 0.9) !important;
}

.text-subtitle-1.primary--text {
  color: rgba(26, 46, 36, 0.8) !important;
}

.text-caption.primary--text {
  color: rgba(26, 46, 36, 0.75) !important;
  font-weight: 500 !important;
}

.secondary--text {
  color: var(--v-secondary-base) !important;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(26, 46, 36, 0.4);
  transition: all 0.3s ease;
  background: rgba(26, 38, 46, 0.8) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #1a2e24;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
}

::v-deep .v-avatar .v-icon {
  color: var(--v-secondary-base) !important;
  filter: drop-shadow(0 4px 12px rgba(var(--v-secondary-base-rgb), 0.6));
}

/* Imágenes */
::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(26, 46, 36, 0.4);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover .v-image {
  border-color: #1a2e24;
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

/* Botones - Oscuros para contrastar */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

/* Botones con fondo oscuro que contrastan */
::v-deep .v-btn.primary,
::v-deep .v-card-actions .v-btn {
  background: linear-gradient(135deg, #1a262e 0%, #0f1a1f 100%) !important;
  color: var(--v-secondary-base) !important;
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

::v-deep .v-btn.primary:hover,
::v-deep .v-card-actions .v-btn:hover {
  background: linear-gradient(135deg, #0f1a1f 0%, #050a0f 100%) !important;
  border-color: var(--v-secondary-base) !important;
  color: #ffffff !important;
}

::v-deep .v-btn.secondary,
::v-deep .v-btn[color='secondary'] {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn.secondary--text {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
  color: var(--v-secondary-base) !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
  color: #ffffff !important;
}

/* Input fields */
::v-deep .v-text-field .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.3) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field__slot label {
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .v-input--is-focused .v-text-field__slot label {
  color: var(--v-secondary-base) !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>

<script>
import { Packer } from 'docx'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import BaseInput from '@src/components/base/BaseInput.vue'
import TextButton from '@src/components/base/TextButton.vue'
import FormatoNoAdeudoAntimotin from '@src/utils/doc-generator/armeria/FormatoNoAdeudoAntimotin'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  data() {
    return {
      loading: false,
      filtroPersonal: '',
    }
  },

  computed: {
    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    ...mapGetters('tipoAmbito', {
      tipoAmbito: 'getTipoAmbito',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },
    hasFoto(personal) {
      const urlSinFoto =
        'https://edofza.eoninnovaction.com/CICG_SEG/ESTADO_FUERZA/Files/Fotografia/frente_AARD930724H214693851.jpg'
      return (
        personal.foto &&
        typeof personal.foto === 'string' &&
        personal.foto.trim() !== '' &&
        personal.foto !== urlSinFoto
      )
    },
    getFullName(personal) {
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre || ''}`.trim()
    },
    download: function (id) {
      window.open(
        'http://ssctlaxcala.eonproduccion.net/tableros/report.php?r=59&u1=' +
          id +
          '&m=1&h=5254dbdeb51eb0435529a6af6dbace7362bdf4db',
        '_blank'
      )
    },

    downloadCartaNoAdeudo: function (cuip) {
      window.open(
        'http://ssctlaxcala.eonproduccion.net/tableros/report.php?r=68&u1=' +
          cuip +
          '&m=1&h=9ae897093104fc9734a959dfb66811f15f7cc110&export=pdf',
        '_blank'
      )
    },

    async generarConstanciaNoAdeudoAntimotin(personal) {
      const nombreCompleto = [personal.apaterno, personal.amaterno, personal.nombre, personal.segundoNombre || '']
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()

      const puesto = personal.CatPuestoDependencia?.catPuesto?.title || 'SIN PUESTO'
      const fecha = new Date().toISOString().slice(0, 10)

      const doc = new FormatoNoAdeudoAntimotin({
        nombre: nombreCompleto,
        puesto: puesto,
        fecha: fecha,
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `FormatoNoAdeudoAntimotin_${nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
